
























import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';


@Component({
  name: 'product-list-toolbar',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop() readonly type: string;

  private get toolbarType(): string {
    return this.type || 'top';
  }

  private get itemCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private mounted(): void {
    this.$nextTick(() => {
      const placeholder = document.getElementById('toolbarPlaceholder');
      if (placeholder) {
        placeholder.style.visibility = 'hidden';
      }
    });
  }
}
